export default __webpack_public_path__ + "img/checked-black.727a71a3.svg";